import { Button, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import '../../css/modal.scss';
import CloseIcon from '../../img/body/close.png';
import Const from "../../const";
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

class ControlChatModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputText: '',
    };
    this.formRef = React.createRef();
  }

  onChangeInputText = (value) => {
    this.setState({ inputText: value });
  };

  getControlUserList = async () => {
    const branchIdx = this.props.loginReducer.loginInfo.branchIdx;
    const pageNum = 1;
    const pageSize = 10000;
    const res = await httpGet(
      httpUrl.branchUserList,
      [branchIdx, pageNum, pageSize],
      {}
    );
    return res.data.branchUsers;
  };

  onSend = () => {
    const self = this;
    Modal.confirm({
      title: '관제문의',
      content: '전송하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      ...modalStyle,
      async onOk() {
        const userList = await self.getControlUserList();
        if (!userList) {
          return;
        }
        let failedIdx = [];
        userList.forEach((user, i) => {
          httpPost(httpUrl.chatSend, [], {
            chatMessage: self.state.inputText,
            receiveUserIdx: user.idx,
            sessionId:
              undefined !== global.ws && null !== global.ws
                ? global.ws.getSessionId()
                : null,
          })
            .then((res) => {
              if (res.result !== 'SUCCESS' || res.data !== 'SUCCESS') {
                failedIdx.push(i);
              }
            })
            .catch((e) => {
              failedIdx.push(i);
            });
        });
        if (failedIdx.length === 0) {
          Modal.info({
            title: '전송성공',
            content: '문의에 성공했습니다. 채팅창을 확인하세요.',
            ...modalStyle,
          });
          self.clearInput();
          self.props.close();
        }
      },
    });
  };

  clearInput = () => {
    this.setState({
      inputText: '',
    });
  };

  render() {
    const { isOpen, close } = this.props;
    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="charge-content-all">
                <div className="charge-content-title">
                  <div className="charge-content-title-text">관제문의</div>
                </div>

                <div className="close-image" onClick={close}>
                  <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
                </div>

                <TextArea
                  style={{
                    borderWidth: 1,
                    borderColor: 'black',
                    height: 200,
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                  value={this.state.inputText}
                  onChange={(e) => this.onChangeInputText(e.target.value)}
                />

                <Button
                  style={{
                    float: 'right',
                    marginBottom: 20,
                    background: 'black',
                    color: skinType === "GOGOIT" ? '#1ECAD3' : '#fddc00',
                  }}
                  onClick={() => this.onSend()}>
                  문의하기
                </Button>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ControlChatModal);
